import React, { useEffect, useState } from "react";
import { setShouldUpdateList, getSubscriptionDetail, cancelSubscription, restartSubscription, updateSubscription } from '../../../slices/subscriptions'
import { updateAddress, createAddress } from "../../../slices/address";
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link } from "react-router-dom";
import { SubscriptionStatus } from "../../../components/status";
import { Button } from "../../../components/button";
import { SvgArrow, SvgCancel, SvgReceipt, SvgRecycleBin } from "../../../components/svg";
import { TransactionTable } from "../../../components/table/table_transactionslist";
import { WebhookTable } from "../../../components/table/table_webhooktable";
// import { ActionTable } from "../../../components/table/table_actiontable";
import SubscriptionForm from "../../../components/forms/subscription-form";
import { SaveIndicator } from "../../../components/save-indicator";
import useModal from "../../../hooks/modal";
import Modal from "../../../components/modal";
import BasicAddressForm from "../../../components/forms/basic-address-form";
import moment from 'moment';
import { AuditLogTable } from "../../../components/table/table_auditloglist";
import ErrorModal from "../../../components/error-modal";
import { ListModal } from "../../../components/list-modal";
import subscriptionsService from "../../../api/subscriptions";
import { getAddress } from "../../../utils";
import { CustomerDetailsCard } from "../../../components/customer_details_card";

const translations = [
    gettext("Stop and invalidate immediately"),
    gettext('Confirm'),
    gettext('Are you sure you want to stop this subscription and invalidate it immediately?'),
    gettext("Stop renewals"),
    gettext('Are you sure you want to stop this subscription?'),
    gettext("Restart renewals"),
    gettext('Are you sure you want to restart this subscription?'),
    gettext("Delivery Address"),
    gettext("Address"),
    gettext("Add delivery address if other than home address"),
    gettext("Edit"),
    gettext("Customer"),
    gettext("Name"),
    gettext("Transactions"),
    gettext("No transactions were found for this subscription"),
    gettext("All transactions"),
    gettext("History"),
    gettext("No actions were found for this subscription"),
    gettext("Full history"),
    gettext('Close'),
    gettext("Webhooks"),
    gettext("No webhooks were found for this subscription"),
    gettext("All webhooks"),
    gettext("History for subscription"),
]


function SubscriptionDetail() {
    let { subscriptionId } = useParams();
    const dispatch = useDispatch()
    const auditLogs = useSelector((state) => state.auditLogs)
    const selectedSubscription = useSelector((state) => state.subscriptions.selectedSubscription)
    const loadingDetail = useSelector((state) => state.subscriptions.loadingDetail)
    const loadingUpdate = useSelector((state) => state.subscriptions.loadingUpdate)
    const deliveryAddress = useSelector((state) => state.subscriptions.selectedSubscription?.delivery_address)
    const plans = useSelector((state) => state.plans.results)
    const [editingAddress, setEditingAddress] = useState(false)

    const [isShowingStopImmediately, toggleStopImmediately] = useModal();
    const [isShowingStopRenewals, toggleStopRenewals] = useModal();
    const [isShowingRestartRenewals, toggleRestartRenewals] = useModal();
    const [isShowingErrorModal, toggleErrorModal] = useModal();
    const [isShowingWebhookListModal, toggleWebhookListModal] = useModal();
    const [isShowingAuditLogListModal, toggleAuditLogListModal] = useModal();


    const stopRenewals = (cancel_remaining) => {
        dispatch(cancelSubscription({ subscriptionId: subscriptionId, args: { cancel_remaining: cancel_remaining, token: selectedSubscription.token } }))
            .then((item) => {
                if (item.error) {
                    toggleErrorModal(true)
                }
            });
        cancel_remaining ? toggleStopImmediately() : toggleStopRenewals();
    }

    const restartRenewals = () => {
        dispatch(restartSubscription({ subscriptionId: subscriptionId, args: { token: selectedSubscription.token } }))
            .then((item) => {
                if (item.error) {
                    toggleErrorModal(true);
                }
                toggleRestartRenewals();
            });
    }

    const subscriptionFormCallback = (data) => {
        dispatch(updateSubscription({ subscriptionId: subscriptionId, args: data }))
            .then((item) => {
                dispatch(setShouldUpdateList())
                if (item.error) {
                    toggleErrorModal(true)
                }
            });
    }

    const renderFirstName = () => {
        if (selectedSubscription.customer.name) {
            let parts = selectedSubscription.customer.name.split(" ")
            if (parts.length > 0) {
                return parts[0]
            } else {
                return selectedSubscription.customer.name
            }
        }
        return ''
    }

    const updateDeliveryAddress = (newAddress) => {
        if (deliveryAddress) {
            dispatch(updateAddress({ id: deliveryAddress.id, args: newAddress }))
                .then(() => dispatch(getSubscriptionDetail({ subscriptionId: subscriptionId })))
                .then(() => setEditingAddress(false))
        } else {
            dispatch(createAddress(newAddress)).then((promise) => {
                dispatch(updateSubscription({ subscriptionId: subscriptionId, args: { delivery_address: promise.payload.id } }))
                    .then(() => dispatch(getSubscriptionDetail({ subscriptionId: subscriptionId })))
                    .then(() => setEditingAddress(false))
            })
        }
    }

    const removeDeliveryAddress = () => {
        dispatch(updateSubscription({ subscriptionId: subscriptionId, args: { delivery_address: null } }))
            .then(() => dispatch(getSubscriptionDetail({ subscriptionId: subscriptionId })))
    }

    // If subscription is expired renewal is disabled
    const renewalDisabled = () => {
        return false
        //return moment(selectedSubscription.active_until).isBefore(moment())
    }



    return (
        <>
            {selectedSubscription &&
                <>
                    {loadingDetail ?
                        <div className="loader top-50 start-50 position-absolute" role="status"></div>
                        :
                        <>
                            <div className="container-fluid">
                                <ErrorModal
                                    showError={isShowingErrorModal}
                                    toggle={toggleErrorModal}
                                />
                                <div className="row">
                                    <div className="col px-0 d-flex justify-content-between align-items-center">
                                        <h1 className="title" title={`${selectedSubscription.plan.name} — ${renderFirstName()}`}>{selectedSubscription.plan.name} — {renderFirstName()}</h1>
                                        <SaveIndicator isSaving={loadingUpdate} />
                                    </div>
                                </div>
                            </div>
                            <div className="contentarea">
                                <div className="container-fluid detail">
                                    <div className="row">
                                        <div className="col-12 mb-4">
                                            <SubscriptionStatus key={subscriptionId} subscription={selectedSubscription} />
                                        </div>
                                    </div>
                                    <SubscriptionForm
                                        key={selectedSubscription.id}
                                        subscription={selectedSubscription}
                                        callback={subscriptionFormCallback}
                                        editing={true}
                                    />
                                    <div className="row">
                                        {selectedSubscription.active ? (
                                            <>
                                                <div className="col-sm-6 mb-4">
                                                    <Button variant={"secondary"} formControl={true} onClick={() => toggleStopImmediately()} icon={<SvgCancel />}>{gettext("Stop and invalidate immediately")}</Button>
                                                    <Modal
                                                        show={isShowingStopImmediately}
                                                        onClose={toggleStopImmediately}
                                                        icon={<SvgCancel />}
                                                        onClick={() => stopRenewals(true)}
                                                        confirmButtonText={gettext('Confirm')}
                                                    >
                                                        <p><strong>{gettext('Are you sure you want to stop this subscription and invalidate it immediately?')}</strong></p>
                                                    </Modal>
                                                </div>
                                                <div className="col-sm-6 mb-4">
                                                    <Button variant={"secondary"} formControl={true} onClick={() => toggleStopRenewals()} icon={<SvgCancel />}>{gettext("Stop renewals")}</Button>
                                                    <Modal
                                                        show={isShowingStopRenewals}
                                                        onClose={toggleStopRenewals}
                                                        icon={<SvgCancel />}
                                                        onClick={() => stopRenewals(false)}
                                                        confirmButtonText={gettext('Confirm')}
                                                    >
                                                        <p><strong>{gettext('Are you sure you want to stop this subscription?')}</strong></p>
                                                    </Modal>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="col-6 mb-4">
                                                <Button variant={"secondary"} formControl={true} onClick={() => toggleRestartRenewals()} disabled={renewalDisabled()} data-bs-toggle="tooltip" data-bs-placement="top" title="Tooltip on top">
                                                    {gettext("Restart renewals")}
                                                </Button>
                                                <Modal
                                                    show={isShowingRestartRenewals}
                                                    onClose={toggleRestartRenewals}
                                                    onClick={() => restartRenewals()}
                                                    confirmButtonText={gettext('Confirm')}
                                                >
                                                    <p><strong>{gettext('Are you sure you want to restart this subscription?')}</strong></p>
                                                </Modal>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {!selectedSubscription.plan.electronic_only &&
                                    <div className="container-fluid detail">
                                        <div className="row align-items-end">
                                            <h2>{gettext("Delivery Address")}</h2>
                                            <div className="row">
                                                <div className="col">
                                                    <div className="form-control mb-3 d-flex flex-column py-3">
                                                        <label className="pb-1">{gettext("Address")}</label>
                                                        {getAddress(selectedSubscription.customer.address)}
                                                    </div>
                                                    {!deliveryAddress && !editingAddress &&
                                                        <Button variant={"secondary"} size={'sm'} onClick={() => setEditingAddress(true)}>{gettext("Add delivery address if other than home address")}</Button>
                                                    }
                                                </div>
                                                {deliveryAddress && !editingAddress &&
                                                    <div className="col-xl-6">
                                                        <div className="form-control mb-3 d-flex flex-column py-3">
                                                            <label className="pb-1">{gettext("Address")}</label>
                                                            {getAddress(deliveryAddress)}
                                                        </div>
                                                        <Button variant={"secondary"} size={'sm'} onClick={() => setEditingAddress(true)}>{gettext("Edit")}</Button>
                                                        <Button variant={"secondary"} size={'sm'} className="ms-3 btn-icon-only px-4" onClick={() => removeDeliveryAddress()}><SvgRecycleBin /></Button>
                                                    </div>
                                                }
                                                {editingAddress &&
                                                    <BasicAddressForm address={deliveryAddress} showSaveButton={true} onSave={(item) => updateDeliveryAddress(item)} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="container-fluid related">
                                    <div className="row">
                                        <div className="col mb-4">
                                            <h2>{gettext("Customer")}</h2>
                                            <CustomerDetailsCard customer={selectedSubscription.customer} />
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                    <div className="col">
                                        <h2>{gettext("Transactions")}</h2>
                                        <div className="table-wrapper mb-3 overflow-scroll">
                                            {selectedSubscription.billing_logs && selectedSubscription.billing_logs.length > 0 ?
                                                <TransactionTable filters={[{ subscription_id: selectedSubscription.id }]} size={'sm'} limit={5} hideFilters={true} addonSearchParams={`subscription=${selectedSubscription.id}`} />
                                                :
                                                <p>{gettext("No transactions were found for this subscription")}</p>
                                            }
                                        </div>
                                        {selectedSubscription.billing_logs && selectedSubscription.billing_logs.length > 0 &&
                                            <div className="text-end">
                                                <Button variant={"secondary"} size={'sm'} component={Link} to={`/transactions/?subscription=${selectedSubscription.id}`}>{gettext("All transactions")}</Button>
                                            </div>
                                        }
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col">
                                            <h2>{gettext("History for subscription")}</h2>
                                            <div className="table-wrapper mb-3 overflow-scroll">
                                                {selectedSubscription.audit_logs && selectedSubscription.audit_logs.length > 0 ?
                                                    <AuditLogTable data={selectedSubscription.audit_logs} />
                                                    :
                                                    <p>{gettext("No actions were found for this subscription")}</p>
                                                }
                                            </div>
                                            {selectedSubscription.audit_logs && selectedSubscription.audit_logs.length > 0 &&
                                            <>
                                                <div className="text-end">
                                                    <Button onClick={toggleAuditLogListModal} variant={"secondary"} size={'sm'}>{gettext("Full history")}</Button>
                                                </div>
                                                {isShowingAuditLogListModal &&
                                                    <ListModal
                                                    show={isShowingAuditLogListModal}
                                                    onClose={toggleAuditLogListModal}
                                                    confirmButtonText={gettext('Close')}
                                                    TableComponent={AuditLogTable}
                                                    apiService={subscriptionsService.getSubscriptionAuditLogs(selectedSubscription.id)}
                                                />
                                                }
                                            </>
                                            }
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col">
                                            <h2>{gettext("Webhooks")}</h2>
                                            <div className="table-wrapper mb-3 overflow-scroll">
                                                {selectedSubscription.latest_webhooks && selectedSubscription.latest_webhooks.length > 0 ?
                                                    <WebhookTable data={selectedSubscription.latest_webhooks || []} size={'sm'} />
                                                    :
                                                    <p>{gettext("No webhooks were found for this subscription")}</p>
                                                }
                                            </div>
                                            {selectedSubscription.latest_webhooks && selectedSubscription.latest_webhooks.length > 0 &&
                                                <>
                                                    <div className="text-end">
                                                        <Button onClick={toggleWebhookListModal} variant={"secondary"} size={'sm'}>{gettext("All webhooks")}</Button>
                                                    </div>
                                                    {isShowingWebhookListModal &&
                                                        <ListModal
                                                            show={isShowingWebhookListModal}
                                                            onClose={toggleWebhookListModal}
                                                            confirmButtonText={gettext('Close')}
                                                            TableComponent={WebhookTable}
                                                            apiService={subscriptionsService.getSubscriptionWebhooks(selectedSubscription.id)}
                                                        />
                                                    }
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </>
    )

}

export default SubscriptionDetail